// ══════════════════════════════════════════════════════════════════════════════
//  Marquee: texto de una linea que se desplaza al pasar el cursor si no cabe.
// ══════════════════════════════════════════════════════════════════════════════

// ── Marquee: texto de una línea que, si no cabe, muestra "…" en reposo y se
// desplaza (pasarela) al pasar el cursor para revelar el resto. CSS puro
// (clase gb-marquee, ver design.js): solo anima en hover y solo via transform.
//
// `alTexto` (2026-10-07, el chip de la obra en la libreta de concreto): mide lo
// que su texto y cede si no cabe. gb-marquee toma su ancho de afuera, porque
// container-type lo mide vacío, y en un renglón flex se quedaba en cero. Aquí
// una copia invisible en la misma celda de una rejilla le da el ancho natural; el
// renglón lo encoge hasta lo que quepa y la pasarela recorre el resto. El estilo
// (fondo, borde, relleno de un chip) va en `style`, sobre la rejilla.
const Marquee = ({ children, title, style:sx, className, alTexto }) => alTexto ? (
  <span className={className} title={title} style={{ display: 'inline-grid',
    gridTemplateColumns: 'minmax(0, auto)', minWidth: 0, maxWidth: '100%', ...sx }}>
    <span aria-hidden="true" style={{ gridArea: '1 / 1', visibility: 'hidden',
      whiteSpace: 'nowrap', overflow: 'hidden' }}>{children}</span>
    <span className="gb-marquee" style={{ gridArea: '1 / 1' }}>
      <span className="gb-marquee-i">{children}</span>
    </span>
  </span>
) : (
  <span className={`gb-marquee${className ? ' ' + className : ''}`} title={title} style={sx}>
    <span className="gb-marquee-i">{children}</span>
  </span>
);


export { Marquee };
